import React, { createContext, useContext, useState, useCallback } from 'react';
import Dialog from '../components/Dialog';

const DialogContext = createContext(null);

export function DialogProvider({ children }) {
  const [dialog, setDialog] = useState(null);

  const showAlert = useCallback((message, options = {}) => {
    return new Promise((resolve) => {
      setDialog({ kind: 'alert', message, resolve, ...options });
    });
  }, []);

  const showConfirm = useCallback((message, options = {}) => {
    return new Promise((resolve) => {
      setDialog({ kind: 'confirm', message, resolve, ...options });
    });
  }, []);

  const showPrompt = useCallback((message, options = {}) => {
    return new Promise((resolve) => {
      setDialog({ kind: 'prompt', message, resolve, ...options });
    });
  }, []);

  const handleClose = useCallback((result) => {
    setDialog((prev) => {
      if (prev?.resolve) prev.resolve(result);
      return null;
    });
  }, []);

  return (
    <DialogContext.Provider value={{ showAlert, showConfirm, showPrompt }}>
      {children}
      {dialog && <Dialog dialog={dialog} onClose={handleClose} />}
    </DialogContext.Provider>
  );
}

export function useDialog() {
  return useContext(DialogContext);
}
